var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"1"}}):_vm._e(),_vm._l((_vm.typeList),function(contractType,index){return _c('RouteListItem',{key:index,attrs:{"node":{
    name: 'Contracts',
    meta: {
      displayName: contractType.Name,
      icon: _vm.getTypeIcon(contractType.Id),
      count: contractType.Count,
      params: { contractTypeId: contractType.Id },
    }
  }}})}),_c('v-divider',{staticClass:"mx-4",staticStyle:{"border-color":"rgb(151 151 151 / 12%)"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }